import React from 'react';
import { Grid, GridItem } from '@chakra-ui/react';
import ItemCard from './item-card';
import { Content, Favorite } from '@/lib/types';

type Props = {
  contents: Content[];
  favorites: { [key: number]: Favorite };
  viewMode: 'list' | 'grid';
  viewFavorites: boolean;
  lastContentElementRef: (node: HTMLDivElement | null) => void;
  onView: (item: Content) => void;
  onFavourite: (item: Content) => void;
  onGeneratePiblicLink: (item: Content) => void;
  onDuplicate: (item: Content) => void;
  onEdit: (item: Content) => void;
  onDelete: (item: Content) => void;
  onChangeStatus: (item: Content, status: 'draft' | 'published') => void;
};

const ItemGrid: React.FC<Props> = ({
  contents,
  favorites,
  viewMode,
  viewFavorites,
  lastContentElementRef,
  onView,
  onFavourite,
  onGeneratePiblicLink,
  onDuplicate,
  onEdit,
  onDelete,
  onChangeStatus,
}) => {
  return (
    <Grid templateColumns={'repeat(auto-fill, minmax(200px, 1fr))'} gap={6}>
      {contents.map((item) =>
        viewFavorites && !favorites[item.id] ? null : (
          <GridItem key={item.id} borderRadius={'md'} display={'flex'} flexDirection={'column'}>
            <ItemCard
              item={item}
              favorites={favorites}
              viewMode={viewMode}
              lastContentElementRef={lastContentElementRef}
              onView={onView}
              onFavourite={onFavourite}
              onGeneratePiblicLink={onGeneratePiblicLink}
              onDuplicate={onDuplicate}
              onEdit={onEdit}
              onDelete={onDelete}
              onChangeStatus={onChangeStatus}
            />
          </GridItem>
        ),
      )}
    </Grid>
  );
};

export default ItemGrid;
